export const GET_VENUE_BY_ID= 'GET_VENUE_BY_ID'
export const GET_VENUE_BY_ID_SUCCESS= 'GET_VENUE_BY_ID_SUCCESS'
export const GET_VENUE_BY_ID_ERROR='GET_VENUE_BY_ID_ERROR'

export const GetVenueById= (data) => ({
    type: GET_VENUE_BY_ID,
    payload: data
})


